import { render, staticRenderFns } from "./callCenter.vue?vue&type=template&id=0993aeb8"
import script from "./callCenter.vue?vue&type=script&lang=js"
export * from "./callCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports